import React from "react";

const index = () => {
  return <div>netflix</div>;
};

export default index;
